import { Injectable } from '@angular/core';
import { JobPositionModel } from './model/job-position.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JobPositionService {

  constructor(private http: HttpClient) { }

  getJobPositionList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/get', requestData);
  }

  getJobPositionById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/get/' + id, '');
  }

  update(jobPositionInfo: JobPositionModel): Observable<any> {
    if (jobPositionInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/update', jobPositionInfo);
    } else {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/add', jobPositionInfo);
    }
  }

  delete(jobPositionInfo: JobPositionModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/delete/' + jobPositionInfo.id, jobPositionInfo);
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/' + environment.app + '/job-position/export-job-position-list', requestData, { headers, responseType: 'blob' });
  }

}
